import './headingDescVsmall.css';

function HeadingDescVsmall(props) {
  const { text } = props;
  return <h6 className="headingDescVsmall"> {text || ''} </h6>;
}

export default HeadingDescVsmall;
